
/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

/* eslint-disable @typescript-eslint/no-explicit-any */
import { CallbackType, FRAuth, FRStep } from '@forgerock/javascript-sdk';
import { Button, TextField } from '@mui/material';

import { useForm } from 'react-hook-form';
import { CheckboxButtonGroup, FormContainer } from 'react-hook-form-mui';


import { useEffect, useRef, useState } from 'react';
import { trees } from '../../../config';
import SuccessErrorModal from '../../modals/SuccessErrorModal';
import FormLayout from '../../layout/form';
import FormSection from '../../01-atoms/FormSection';
import Row from '../../01-atoms/Row';
import { BaseCallBackInterface } from './basInterface';
import CustomCheckBox from '../../../util/component/CustomCheckBox';
import CustomFormContainer from '../../layout/CustomFormContainer';



export default function AcceptTermsAndConditions({ step,
  setStep,
  tree,
  messageType,
  setMessageType,
  message, setMessage,
  isAlertOpen,
  setIsAlertOpen }: BaseCallBackInterface) {
  const formContext = useForm<{}>({
    defaultValues: {
    }
  });
  const parsedDom:Document = new DOMParser().parseFromString(step.getCallbackOfType(CallbackType.TermsAndConditionsCallback).getOutputValue(1) as string, "text/html");
 

  //  used for the modal

  const [enableSubmit,setEnableSubmit]=useState(false);

  //  ---------------------METHODS-----------------------------------

  function fillStep(step: FRStep, data: any): void {
    handleClose();
    const fillStep = step;
    fillStep.getCallbackOfType(CallbackType.TermsAndConditionsCallback).setInputValue(data.termsAndConditions);
    setStep(fillStep);
  }

  const handleSuccess = async (data: any) => {
    fillStep(step as FRStep, data);
    const nextStep = await FRAuth.next(step as FRStep, { tree });
    if (nextStep.type === 'LoginFailure') {
      setIsAlertOpen(true);
      setMessage(nextStep.payload.message || '');
      // nextStep = await FRAuth.start({ tree });
    } else {
      setIsAlertOpen(false);
    }
    setStep(nextStep);
  };

  const handleOpen = () => {
    setIsAlertOpen(true);
  };
  const handleClose = () => {
    setIsAlertOpen(false);
  };


  const listInnerRef = useRef<HTMLDivElement>(null);

  

  const onScroll = () => {
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
      //console.log("============> " ,scrollHeight, scrollTop, clientHeight,scrollTop + clientHeight+1, scrollTop + clientHeight+(clientHeight/2.3) )
      if (scrollTop + clientHeight+156 >= scrollHeight) {

        //156 is (clientHeight/2.3) as we have to see if the content is scrolled enough
        setEnableSubmit(true)
      }
    }
  };

  useEffect(()=>{
   
      const element =  document.getElementById('TNC'); 
      if(!!element){
        //element.innerHTML = step.getCallbackOfType(CallbackType.TermsAndConditionsCallback).getOutputValue(1) as string;
    }
     
  },[])

  //  -----------------END METHODS-----------------------------------

  return (
    <CustomFormContainer
      defaultValues={{}}
      formContext={formContext}
      onSuccess={handleSuccess}>
      <SuccessErrorModal
        open={isAlertOpen}
        type={messageType}
        handleClose={handleClose}
        message={message}/>
      <FormLayout
        header={step.getHeader()}
        subHeader={step.getDescription()}
        button={<button  id="submit_button" className={`accent-1 submit`}  type="submit" disabled={formContext.getValues('termsAndConditions'as never) as boolean}>Submit</button>}>
        <FormSection>
          
            <div
             style={{height:'359px',width:'402px',overflow:'hidden',overflowY:'auto',border:"0.5px solid #E3E5E8", padding:"10px 10px",marginBottom:'24px'}}
             onScroll={onScroll}
             ref={listInnerRef}
            >
            <span
            id="TNC"
              key="TNC"
              dangerouslySetInnerHTML={{__html:(step.getCallbackOfType(CallbackType.TermsAndConditionsCallback).getOutputValue(1) as string)}}
               />
             </div>  
          <Row>
            <div className = {"termsAndConditionsStyles"}>
            <CustomCheckBox
              required
              // label=""
              name="termsAndConditions"
              disabled={!enableSubmit}
              
              // options={[
              //   {
              //     id: true,
              //     label: 'I Accept the Terms and Conditions on behalf of my company'
              //   }
              // ]}
              label= 'I have read and accept the terms and conditions on behalf of my company.'
              /></div>
          </Row>
        </FormSection>
      </FormLayout>
    </CustomFormContainer>
  );
}
